import { AddressPickUp } from "./address-pickup";

export class InternationalPickup {
  static sourcePickup: InternationalPickup;
  public RequesterName: string;
  public RequesterPhoneNumber: string;
  public RequesterAccount: string;
  public PickupAddress: AddressPickUp;
  public RecipientAddress: AddressPickUp;
  public PackagesNumber: string;
  public PalletsNumber: string;
  public ReturnReference: string;
  public Weight: string;
  public Length: string;
  public Width: string;
  public Height: string;
  public Observations: string;
  public BookingReference: string;
  public PickupDate: Date;  
  public Awb: string;
  public ContentDescription: string;
  public DeclaredValue: string;
  public Currency: string;    
  public Id: string;
}
